'use client'

import { Text } from '@components/primitives/Text'
import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { NO_CONDITIONS_VALUE } from '@lib/questionnaire/trialApplication/generatePrescreeningQuestionConfig'
import { isNotEmptyOrSkippedAnswer } from '@modules/patientApplyProfile/helpers/PatientApplyProfileData'
import { useState } from 'react'
import { PopularItems } from './PopularItems.client'
import { SearchInput } from './SearchInput.client'
import { SelectedItems } from './SelectedItems.client'
import { getPopularMedications } from './getPopularMedications'
import type { ConditionCollectElementProps } from './types'

export default function CollectCurrentMedications({
  nctId,
  patientProfileData,
  therapeuticAreas,
  treatmentsByFrequency,
}: ConditionCollectElementProps) {
  const conditionToShowMedicationsFor = patientProfileData.conditions.filter(
    (condition) => condition !== NO_CONDITIONS_VALUE,
  )[0]

  // TO DO: in the future if we are fetching from our DB to get concepts by frequency then
  // we should probably update to use conceptId as key
  const mostPopularMedicationNames = getPopularMedications({
    condition: conditionToShowMedicationsFor,
    nctId,
    therapeuticAreas,
  }).map((medication, index) => ({
    displayName: medication.displayName,
    frequency: 1,
    id: index,
    name: medication.value,
  }))

  const [currentMedications, setCurrentMedications] = useState(
    patientProfileData.currentMedications.filter(isNotEmptyOrSkippedAnswer),
  )

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element='p'
        styleName='h3'
        value={`What medication(s) are you taking for ${conditionToShowMedicationsFor ? conditionToShowMedicationsFor : 'your condition'}?`}
      />
      <Text
        className='text-neutral900'
        element='p'
        styleName='p-small'
        value='You can add multiple answers'
      />

      <SearchInput
        itemsByFrequencyCollection={treatmentsByFrequency}
        menuPlacement='bottom'
        onChange={setCurrentMedications}
        placeholder='Search for Other Medications'
        searchTitle=''
        trackingType='currentMedication'
        value={currentMedications}
      />

      <SelectedItems
        icon={faCapsules}
        onChange={setCurrentMedications}
        title='Selected Medications'
        trackingType='currentMedication'
        value={currentMedications}
      />

      {currentMedications.filter(Boolean).map((currentMedication) => (
        <input
          key={currentMedication}
          name={'currentMedications'}
          type='hidden'
          value={currentMedication}
        />
      ))}

      <PopularItems
        addNoneOption
        itemsByFrequency={mostPopularMedicationNames}
        onChange={setCurrentMedications}
        title='Common Related Medications'
        trackingType='currentMedication'
        value={currentMedications}
      />
    </div>
  )
}
